import { render, staticRenderFns } from "./FormGetPaymentMethod.vue?vue&type=template&id=0c968c8c&scoped=true&"
import script from "./FormGetPaymentMethod.vue?vue&type=script&lang=js&"
export * from "./FormGetPaymentMethod.vue?vue&type=script&lang=js&"
import style0 from "./FormGetPaymentMethod.vue?vue&type=style&index=0&id=0c968c8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c968c8c",
  null
  
)

export default component.exports